// extracted by mini-css-extract-plugin
export default {"menu":"SortMenu_menu__XvvUl","titleContainer":"SortMenu_titleContainer__kC33e","eraser":"SortMenu_eraser__4Ujku"};